<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.842 0a9.842 9.842 0 1 0 9.84 9.84C19.68 4.408 15.276.003 9.842 0zm.444 14.672a.846.846 0 0 1-.935.934h-.203a.846.846 0 0 1-.934-.934v-.265a.846.846 0 0 1 .934-.934h.203a.846.846 0 0 1 .935.934v.265zm2.23-4.549a3.918 3.918 0 0 1-2.274 1.09c-.052.02-.077.047-.077.077v.577a.932.932 0 0 1-.264.677.96.96 0 0 1-1.34 0 .932.932 0 0 1-.264-.677v-1.18a.937.937 0 0 1 .265-.679.894.894 0 0 1 .669-.272c.589.03 1.17-.14 1.65-.483a1.77 1.77 0 0 0 .624-1.495 1.68 1.68 0 0 0-.56-1.293 2 2 0 0 0-1.403-.514 2.218 2.218 0 0 0-1.51.577c-.207.21-.486.332-.78.342a.825.825 0 0 1-.529-.186.868.868 0 0 1-.11-1.385 3.968 3.968 0 0 1 1.316-.895 4.103 4.103 0 0 1 1.616-.32 3.923 3.923 0 0 1 1.931.484c.571.313 1.05.772 1.385 1.33.34.561.519 1.206.514 1.863a3.235 3.235 0 0 1-.862 2.362h.004z" fill="#1D1D1D" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconFaq',
};
</script>
